import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveSeo } from "./resolveSeo";

function setTag(tag, attrs, content) {
  const el = document.createElement(tag);
  el.setAttribute("data-seo", "");
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  if (content != null) el.textContent = content;
  document.head.appendChild(el);
}

/** Keeps <head> metadata in sync with the current route on the client.
 *  The first paint already has the right tags (prerendered); this only
 *  matters for client-side navigation. Renders nothing. */
export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveSeo(pathname);
    document.documentElement.lang = seo.lang;
    document.head.querySelectorAll("[data-seo]").forEach((n) => n.remove());

    document.title = seo.title;
    setTag("meta", { name: "description", content: seo.description });
    setTag("meta", { name: "robots", content: seo.robots });
    setTag("link", { rel: "canonical", href: seo.canonical });
    seo.alternates.forEach((a) =>
      setTag("link", { rel: "alternate", hreflang: a.hreflang, href: a.href })
    );
    const o = seo.og;
    [
      ["og:type", o.type],
      ["og:site_name", o.siteName],
      ["og:title", o.title],
      ["og:description", o.description],
      ["og:url", o.url],
      ["og:image", o.image],
      ["og:locale", o.locale],
      ["og:locale:alternate", o.alternateLocale],
      ["twitter:card", "summary_large_image"],
      ["twitter:title", o.title],
      ["twitter:description", o.description],
      ["twitter:image", o.image],
    ].forEach(([k, v]) =>
      setTag("meta", { [k.startsWith("twitter") ? "name" : "property"]: k, content: v })
    );
    seo.jsonLd.forEach((obj) =>
      setTag("script", { type: "application/ld+json" }, JSON.stringify(obj))
    );
  }, [pathname]);

  return null;
}
